
















































import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import BasicVideoPlayer from "@/components/organisms/media/BasicVideoPlayer.vue";
import DialogCloseNavigation from "@/components/molecules/DialogCloseNavigation.vue";
import { VueEventTypes } from "@/events/AppEvent";
import { MovieContentsParams } from "@/interfaces/ContentsParams";
import vuescroll from "vuescroll";
import { innerVueScrollOption } from "@/libs/Options";


@Component({
  components: {
    BasicVideoPlayer,
    DialogCloseNavigation,
    vuescroll
  }
})
export default class StatementMovieDialog extends Vue {
  @Prop({ default: false }) isShown: boolean;
  @Prop({ default: '#191919'}) cardColor: string;
  @Prop({ default: null }) contents: MovieContentsParams;

  public videoPlayer: BasicVideoPlayer;

  // テキストコンテンツのスクロールバーの設定オプション
  private scrollOptions = innerVueScrollOption;

  /**
   * 表示・非表示プロパティ
   * プロパティバインドisShownを使って表示
   * 非表示時は'close'をEmitして双方向バインディングを実現する
   *
   */
  get isShownDialog (): boolean {
    return this.isShown;
  }
  set isShownDialog (value: boolean) {
    if (!value) {
      if (this.isShown) {
        this.onCloseDialog();
      }
    }
  }

  get publicPath (): string {
    return this.$store.state.publicPath;
  }

  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }


  /* Lifecycle Hook */
  mounted (): void {
    this.$nextTick(() => {
      this.videoPlayer = <BasicVideoPlayer> this.$refs.videoPlayer;
    });
  }


  /* Close Event Emit */
  @Emit(VueEventTypes.CLOSE_CONTENTS)
  onCloseDialog (): void {
    console.log('Close Movie Dialog');
    // @ts-ignore
    this.videoPlayer.pauseVideo();
    // BGMを再生
    this.$store.commit('bgm/playBgm');
    // 非表示アニメーション後にビデオプレイヤーをリセット
    setTimeout(() => {
      // @ts-ignore
      this.videoPlayer.reset();
      // スクロールをリセット
      const scroll: vuescroll = <vuescroll> this.$refs.vScroll;
      scroll.scrollTo({ y: 0 }, 0);
    }, 300);
  }
}
